import { createFileRoute } from '@tanstack/react-router'
import DashboardContainer from 'Dashboard/containers/DashboardContainer'

export const Route = createFileRoute('/')({
    component: DashboardContainer,
})
